import { ReactElement, useState } from 'react';
import Select from 'react-select';
import tools from '../../../../utils/tools';

const Prices = ({ form, setForm, stores, brands, cars }) => {

  const list = () => {
    const rows: ReactElement[] = []

    form?.variations?.map((variant, index) => {
      rows.push(
        <div className={`AddInfoContainer ${index % 2 != 0 ? 'backgroundGrey' : ''}`} key={index}>
          <label>قیمت خرید</label>
          <input className="persianName" defaultValue={variant.buyPrice} onChange={(input) => setForm((prev) => {
              const cp = prev.variations;

              cp[index].buyPrice = input.target.value;

              return { ...prev, variations: cp };
          })}/>
          <label>قیمت فروش</label>
          <input className="persianName" defaultValue={variant.sellPrice} onChange={(input) => setForm((prev) => {
            const cp = prev.variations;

            cp[index].sellPrice = input.target.value;

            return { ...prev, variations: cp };
          })}/>
          <label>مدت اعتبار(ساعت)</label>
          <input className="persianName" defaultValue={variant.validTime} onChange={(input) => setForm((prev) => {
            const cp = prev.variations;

            cp[index].validTime = input.target.value;

            return { ...prev, variations: cp };
          })}/>
          {/* <label>ماشین</label> */}
          {/* <Select options={tools.selectFormatter(cars, 'id', 'slug', 'انتخاب کنید')} value={tools.selectFormatter(cars.filter(e => e.id == variant.carId), 'id', 'slug')} className="width100" */}
          {/*         onChange={(selected) => setForm((prev) => { */}
          {/*           const cp = prev.variations; */}

          {/*           cp[index].carId = selected.value; */}

          {/*           return { ...prev, variations: cp }; */}
          {/*         })} */}
          {/* /> */}
          <label>برند</label>
          <Select options={tools.selectFormatter(brands, 'id', 'title', 'انتخاب کنید')} value={tools.selectFormatter(brands.filter(e => e.id == variant.brandId), 'id', 'title')} className="width100"
                  onChange={(selected) => setForm((prev) => {
                    const cp = prev.variations;

                    cp[index].brandId = selected.value;

                    return { ...prev, variations: cp };
                  })}
          />
          <label>فروشگاه</label>
          <Select options={tools.selectFormatter(stores, 'id', 'title', 'فروشگاه جدید')} value={{ value: variant?.store?.id, label: stores.find(e => e.id == variant.store?.id)?.title }} className="width100" id="infoTitle" onChange={(selected: any) => setForm((prev) => {
            const cp = prev.variations;
            if (!cp[index].store){
              cp[index].store = { id: '' }
            }
            cp[index].store.id = selected.value;

            return { ...prev, variations: cp };
          })}/>
          {!variant?.store?.id &&
              <>
          <span className="blueText billHeader">
            فروشگاه جدید
          </span>
              <label>عنوان فروشکاه</label>
              <input className="persianName" value={variant?.store?.title} onChange={(input) => setForm(prev => {
                const cp = prev.variations

                cp[index].store.title = input.target.value

                return { ...prev, variations: cp };
              })} />
              <label >شماره تلفن</label>
              <input className="persianName" value={variant?.store?.phoneNumber} onChange={(input) => setForm(prev => {
                const cp = prev.variations

                cp[index].store.phoneNumber = input.target.value

                return { ...prev, variations: cp };
              })} />
              <label>آدرس</label>
              <textarea className="persianName" onChange={(input) => setForm(prev => {
                const cp = prev.variations

                cp[index].store.address = input.target.value

                return { ...prev, variations: cp };
              })} >{variant?.store?.address}</textarea>
            </>
          }
        </div>
      )
    })
    return rows
  };
  return (
    <>
      {list()}
      <span className="addProductButton" onClick={() => setForm(prev => {
        const cp = prev?.variations || [];

        cp[cp.length] = {
          buyPrice: 0,
          sellPrice: 0,
          store: { id: '' },
          brandId: '',
          // carId: form?.carId,
          productId: form?.productId
        }

        return {
          ...prev,
          variations: cp
        };
      })}>اضافه کردن مورد دیگر
      </span>
    </>
  );

};

export default Prices;
